import Rails from '@rails/ujs';
import '@hotwired/turbo-rails';
import { Application } from '@hotwired/stimulus';
import alertController from './src/controllers/alert_controller';

Rails.start();
const application = Application.start();
application.register('alert', alertController);
